<template>
  <div class="attendance-clock-record-page">
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="任务名称">
              <el-input
                v-model="searchCondition.task_name"
                placeholder="请输入任务名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="人员名称">
              <el-input
                v-model="searchCondition.person_name"
                placeholder="请输入人员名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
              <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="tableList"
          :columns="columns"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="打卡时间" min-width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.clock_time">{{ scope.row.clock_time }}</span>
              <span v-else class="empty-text">未打卡</span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";

export default {
  name: "AttendanceClockRecord",
  components: {
    PageHeaderLayout,
    ApeTable,
  },
  data() {
    return {
      loadingStatus: false,
      searchCondition: {
        task_name: "",
        person_name: "",
      },
      columns: [
        {
          title: "任务名称",
          value: "task_name",
          header_align: "center",
          align: "center",
          min_width: 180,
        },
        {
          title: "人员名称",
          value: "person_name",
          header_align: "center",
          align: "center",
          min_width: 120,
        },
      ],
      tableList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      offset: 0,
    };
  },
  methods: {
    isValidValue(value) {
      return value !== "" && value !== undefined && value !== null;
    },
    searchButton() {
      this.init("search");
    },
    resetSearch() {
      this.searchCondition = {
        task_name: "",
        person_name: "",
      };
      this.init("search");
    },
    switchPaging() {
      this.init();
    },
    handleSearchCondition() {
      const condition = {};
      if (this.isValidValue(this.searchCondition.task_name)) {
        condition.task_name = this.searchCondition.task_name;
      }
      if (this.isValidValue(this.searchCondition.person_name)) {
        condition.person_name = this.searchCondition.person_name;
      }
      return condition;
    },
    async init(type) {
      if (type && this.mxResetPage) {
        this.mxResetPage();
      }
      this.loadingStatus = true;
      try {
        const pagingInfo = this.$refs.apeTable
          ? this.$refs.apeTable.getPagingInfo(type)
          : { current_page: 1, page_size: 10 };
        if (type === "search") {
          pagingInfo.current_page = 1;
        }
        const params = Object.assign({}, this.handleSearchCondition(), pagingInfo);
        const res = await this.$api.getAttendanceClockRecordList(params);
        this.tableList = res.data || [];
        this.pagingData.total = (res.pages && res.pages.total) || 0;
        this.offset = (res.pages && res.pages.offset) || 0;
      } finally {
        this.loadingStatus = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.table-search
  margin-bottom 12px

.empty-text
  color #909399
</style>
